import { Waitlist } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { AuthPageFooter } from '@/components/auth/auth-page-footer';
import { AuthPageSiteLinks } from '@/components/auth/auth-page-site-links';
import { APP_NAME } from '@/config/app';
import { usePageTitle } from '@/hooks/use-page-title';

export const Route = createFileRoute('/waitlist/$')({
    component: WaitlistPage,
});

function WaitlistPage() {
    const { t } = useTranslation();
    usePageTitle(t('pageTitle.waitlist'));
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4">
            <CornerLanguageSelector />
            <div className="max-w-md text-center">
                <h1 className="text-2xl font-semibold">
                    {t('waitlist.heading', { appName: APP_NAME })}
                </h1>
                <p className="mt-2 text-sm text-muted-foreground">
                    {t('waitlist.subtext')}
                </p>
            </div>
            <AuthPageSiteLinks />
            <Waitlist signInUrl="/sign-in" />
            <AuthPageFooter />
        </div>
    );
}
